export default [
  {
    path: '/member/login',
    name: 'login',
    meta: {
      requiresAuth: false
    },
    component: () => import('@/components/member/login')
  },
  {
    path: '/member/adminLogin',
    name: 'adminLogin',
    meta: {
      requiresAuth: false
    },
    component: () => import('@/components/member/adminLogin')
  },
  {
    path: '/member/find_info',
    name: 'findInfo',
    meta: {
      requiresAuth: false
    },
    component: () => import('@/components/member/find_info')
  },
  {
    path: '/member/find_info_admin',
    name: 'findInfoAdmin',
    meta: {
      requiresAuth: false
    },
    component: () => import('@/components/member/find_info_admin')
  },
  {
    path: '/member/agreement',
    name: 'agreement',
    meta: {
      requiresAuth: false
    },
    component: () => import('@/components/member/agreement')
  },
  {
    path: '/member/admin_agreement',
    name: 'adminAgreement',
    meta: {
      requiresAuth: false
    },
    component: () => import('@/components/member/adminAgreement')
  },
  {
    path: '/member/reset_password/:isAdmin',
    name: 'resetPassword',
    meta: {
      requiresAuth: false
    },
    component: () => import('@/components/member/ResetPassword')
  }
]



// WEBPACK FOOTER //
// ./src/router/subRoutes/memberRouter.js